<template>
  <div v-if="customer" class="trip-main">
    <div class="content-block">
      <div class="customer-text" v-if="!redactForm">
        <div class="item-info">
          <strong>Клиент:</strong>
          <select class="imput-block-item" id="tariffType" v-model="form.id" @change="handleCustomerChange">
            <option v-for="customer_l in customers" :key="customer_l.id" :value="customer_l.id">{{ customer_l.name }}</option>
          </select>
        </div>
        <div class="item-info">
          <strong>Условия:</strong>
          <p class="conditions" v-if="selectedCustomer">{{ selectedCustomer.transport_conditions }}</p>
          <p v-else>Нет условий</p>
        </div>
      </div>
    </div>
      

  </div>
</template>

<script>
import {computed,ref} from 'vue'
import { useStore } from 'vuex'
export default {
  name: 'CustomerTripInfo',
  props: ['customer','redact','customer_id'],
  setup(props,{emit}){
    const store = useStore();
    const redactForm = ref(false)
    const delConfirm = ref(false)

    const form = ref({
      id:props.customer_id,
      name:props.customer.name,
      inn:props.customer.inn
    })

    // Обработка изменения клиента в списке
    const handleCustomerChange = () => {
      emit('updateCustomer',selectedCustomer.value.id)
    };

    const openClose = btn =>{
      redactForm.value = !redactForm.value
    }
    const customers = computed(() => store.state.apiStorage.options.customers)
    const selectedCustomer = computed(() => {
      if(customers.value){
        return customers.value.find((customer) => customer.id === form.value.id) || null;
      }
      return []
    });
    const saveForm = () =>{
      emit('updateItem',{form:form.value,model:'customers'})
      redactForm.value = false
    }

    const deleteCustomer = ()=>{
      emit('updateTrip',{ delete:'customer' })
    }

    return{
      handleCustomerChange,
      selectedCustomer,
      customers:customers,
      delConfirm,
      deleteCustomer,
      redactForm,
      openClose,
      saveForm,
      form,
    }
  }
};
</script>

<style scoped>
.trip-main{
  padding: 25px 10px;
  border-radius: 10px;
  margin-top: 15px;
  border: 1px solid #ccc;

}


.content-block{
  display: flex;
  align-items: center;
  flex-direction: column;
  flex: 1; /* Добавьте это свойство, чтобы блоки занимали одинаковое пространство */
  padding: 10px; /* Добавьте отступ для блоков, чтобы сделать их более просторными */
  box-sizing: border-box; /* Учтите отступы внутри блоков */
}

.content-block div {
  width: 100%;
}

.white-text{
  color: white;
  padding: 1px;
}

.item-info{
  margin-bottom: 5px;
  display: flex;
  padding: 2px;
}
.item-info p {
  font-size: 14px;
  margin-left: 10px;
}

.center{
  margin-left: 30px;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.button-container {
  margin-top: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.redact-btn {
  padding: 4px;
  margin-left: 5px;
  border-radius: 5px;
  border: 1px solid #ccc;
}

.mt-10{
  margin-top: 15px;
}

.form-input{
  padding: 2px;
  border-radius: 3px;
  border: 1px solid #ccc;
  margin-bottom: 3px;
}
.text-content{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.tms-button-send{
  margin-top: 20px;
  display: flex;
  align-items: center;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 10px;
}

.tms-button-send p{
  margin-left: 10px;
  margin-right: 10px;
  font-size: 14px;
}


.save-button {
  color: white;
  margin-right: 5px;
  margin-top: 2px;
  padding: 3px 12px;
  background-color: #007bff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.delete-btn {
  padding: 2px 8px; 
  border: 1px solid #C33245;
  border-radius: 4px;
  background-color: #C33245;
  color: #fff;
  cursor: pointer;
}

.customer-text{
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-bottom: 20px;
}

.imput-block-item{
  margin-left: 15px;
}

.conditions{
  padding-left: 10px;
  border-left: 1px solid #818181;
}
</style>